import 'Dictionaries/i18n';

import ContractGenerator from 'Components/ContractGenerator';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ResizeConsumer, ResizeProvider } from 'react-resize-context';
import { contractGeneratorOperations, contractGeneratorSelectors } from 'Redux/ducks/contractGenerator';
import { SnackbarContainer } from 'ViatoUi/Shared/Feedback/Snackbar';
import { FlexBox } from 'ViatoUi/Shared/Layouts/Flex';
import Tooltip from 'ViatoUi/Shared/Surfaces/Tooltip';

import styles from './App.module.scss';

const App = () => {
	const dispatch = useDispatch();

	const width = useSelector(contractGeneratorSelectors.getWindowWidth);
	const height = useSelector(contractGeneratorSelectors.getWindowHeight);

	const addMaximumScaleToMetaViewport = () => {
		const el = document.querySelector('meta[name=viewport]');

		if (el !== null) {
			let content = el.getAttribute('content');
			const re = /maximum-scale=[0-9.]+/g;

			if (re.test(content)) {
				content = content.replace(re, 'maximum-scale=1.0');
			} else {
				content = [content, 'maximum-scale=1.0'].join(', ');
			}

			el.setAttribute('content', content);
		}
	};

	const disableIosTextFieldZoom = addMaximumScaleToMetaViewport;

	const checkIsIOS = () => /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

	if (checkIsIOS()) {
		disableIosTextFieldZoom();
	}

	useEffect(() => {
		if (width === null || height === null) {
			dispatch(contractGeneratorOperations.setWindowSize({ width: window.innerWidth, height: window.innerHeight }));
		}
	}, [width, height]);

	return (
		<>
			<ResizeProvider>
				<ResizeConsumer
					className={styles.screenSizeElem}
					onSizeChanged={size => {
						dispatch(contractGeneratorOperations.setWindowSize(size));
					}}
				/>
			</ResizeProvider>
			<FlexBox alignItems='center' flexDirection='column'>
				<ContractGenerator />
			</FlexBox>
			<SnackbarContainer />
			<Tooltip />
		</>
	);
};

export default App;
